<template>
	<div class="container">
		<div class="row">
			<div class="col-12">

				<div class="swiper-container-wrap two-sliders__wrap two-sliders__wrap--with-pagination">

					<div class="swiper-container swiper-container__one" ref="mySwiperOne">

						<div class="swiper-pagination__wrap">
							<h4 v-if="isresidencies" class="swiper-pagination__title">{{msg.residence_type}}:</h4>
							<h4 v-else class="swiper-pagination__title">{{msg.room_type}}:</h4>
							<div class="swiper-pagination swiper-no-swiping">
							</div>
						</div>

						<div class="swiper-wrapper">
							<!-- Slides -->
								<div v-for="slide in this.rooms" :key="slide.id" class="swiper-slide">
									<a :href="slide.friendly_path" class="swiper-slide__link">

										<div class="swiper-slide__img-wrap">
											<img class="swiper-slide__img" :src="slide.article_osnovna_slika_url" alt>
										</div>

									</a>
								</div>
						</div>

					</div>


					<div class="swiper-container swiper-container__two" ref="mySwiperTwo">

						<div class="swiper-wrapper">
							<!-- Slides -->
							<div v-for="slide in this.rooms" :key="slide.id" class="swiper-slide">
								<div  class="swiper-slide-card">
									<header class="swiper-slide-card__header swiper-slide-card__header--no-overlay">
										<div class="swiper-slide-card__header-title-wrap swiper-slide-card__header-title-wrap--no-image">	
											<p class="swiper-slide-card__header-overtitle">{{ slide.article_aboveheadline }}</p>
											<h3 class="swiper-slide-card__header-title">{{ slide.headline }}</h3>
											<p v-if="slide.custom_fields.room_size != '' " class="swiper-slide-card__header-information"><span>{{msg.room_size}}:</span> {{slide.custom_fields.room_size}} / <span>{{msg.room_sleeps}}:</span> {{slide.custom_fields.room_sleeps}} </p>

										</div>
									</header>

									<div class="swiper-slide-card__body">
										<p v-html="slide.article_abstract"></p>
									</div>

									<footer class="swiper-slide-card__footer swiper-slide-card__footer--dir-column">
										<a :href="enquiryUrl + slide.custom_fields.synxis_id" class="btn btn-secondary btn-md">{{msg.book_now}}</a>
										<a class="btn btn-primary btn-md" :href="slide.friendly_path">{{msg.read_more}}</a>
									</footer>
								</div>
							</div>
						</div>

						<div class="swiper-button-prev">
							<svg class="progress-ring" width="70" height="70">
								<circle class="progress-ring__circle progress-ring__circle--left" stroke="#ff7843" stroke-width="2" fill="transparent" r="35" cx="35" cy="35"></circle>
							</svg>
						</div>
						<div class="swiper-button-next">
							<svg class="progress-ring" width="70" height="70">
								<circle class="progress-ring__circle progress-ring__circle--right" stroke="#ff7843" stroke-width="2" fill="transparent" r="35" cx="35" cy="35"></circle>
							</svg>
						</div>


					</div>

				</div>

			</div>
		</div>
	</div>
</template>
<script>
import Swiper from "swiper";
import { mapState } from "vuex";

	export default {
		props: {
			rooms: Object,
			isresidencies: Boolean,
			endpoint: String,
		},
		data: () => ({
			selected: 'All',
			mySwiperOne: {},
			mySwiperTwo: {},
			startingPosition: 0,
			isLoading: false,
			activeFilter: "All",
			slides: [
			{
				id: "1",
				title: "Restaurants & Bars",
				content: "First accomodation",
				price: "200",
				category: "prva",
				text: "Spending the summer in Dubrovnik not only means enjoying its beauties, but also the variety of events that the hosts have prepared for visitors to this Croatian gem. Besides numerous cultural and sporting events, make sure you don’t miss the Sun Gardens Summer Festival. In the warm summer nights, enjoy the lively atmosphere, sipping a glass of wine, sparkling wine or cocktail in attractive locations with a sea view. Could anything be better?"
			},
			{
				id: "2",
				title: "WELLNESS",
				content: "2 accomodation",
				price: "750",
				category: "druga",
				text: "Spending the summer in Dubrovnik not only means enjoying its beauties, but also the variety of events that the hosts have prepared for visitors to this Croatian gem."
			},
			{
				id: "3",
				title: "POOLS & BEACH",
				content: "3 accomodation",
				price: "252",
				category: "prva",
				text: "Spending the summer in Dubrovnik not only means enjoying its beauties, but also the variety of events that the hosts have prepared for visitors to this Croatian gem. Slide 3"
			},
			{
				id: "4",
				title: "SPORTS",
				content: "4 accomodation",
				price: "450",
				category: "druga",
				text: "Slide 4. Besides numerous cultural and sporting events, make sure you don’t miss the Sun Gardens Summer Festival. In the warm summer nights, enjoy the lively atmosphere, sipping a glass of wine, sparkling wine or cocktail in attractive locations with a sea view. Could anything be better?"
			},
			{
				id: "5",
				title: "KIDS",
				content: "5 accomodation",
				price: "100",
				category: "prva",
				text: "Spending the summer in Dubrovnik not only means enjoying its beauties, but also the variety of events that the hosts have prepared for visitors to this Croatian gem. Besides numerous cultural and sporting events, make sure you don’t miss the Sun Gardens Summer Festival. In the warm summer nights, enjoy the lively atmosphere, sipping a glass of wine, sparkling wine or cocktail in attractive locations with a sea view. Slide 5."
			},
			{
				id: "6",
				title: "RESORT ENTERTAINMENT",
				content: "6 accomodation",
				price: "2000",
				category: "prva",
				text: "Spending the summer in Dubrovnik not only means enjoying its beauties, but also the variety of events that the hosts have prepared for visitors to this Croatian gem. Besides numerous cultural and sporting events, make sure you don’t miss the Sun Gardens Summer Festival. In the warm summer nights, enjoy the lively atmosphere, sipping a glass of wine, sparkling wine or cocktail in attractive locations with a sea view. Slide 6."
			}
			]
		}),
		mounted() {
		
			let slides = this.rooms;
			this.mySwiperOne = new Swiper(".two-sliders__wrap--with-pagination .swiper-container__one", {
				slidesPerView: 1,
				spaceBetween: 90,
				// observer: true,
				pagination: {
					el: '.two-sliders__wrap--with-pagination .swiper-container__one .swiper-pagination',
					// type: 'bullets',
					type: 'bullets',
					clickable: true,
					renderBullet: function (index, className) {
						// return '<span class="' + className + '">' + (index + 1) + '</span>';
						return '<span class="' + className + '">' + slides[index].headline + '</span>';
					}
					/*renderCustom: function (swiper, current, total) {
						return current + ' of ' + total;
					}*/
				},
				navigation: {
					nextEl: '.two-sliders__wrap--with-pagination .swiper-button-next',
					prevEl: '.two-sliders__wrap--with-pagination .swiper-button-prev',
				},
				breakpoints: {
					991: {
						slidesPerView: 1,
						spaceBetween: 20
					}
				},
			

			}),
			this.mySwiperTwo = new Swiper(".two-sliders__wrap--with-pagination .swiper-container__two", {
				// observer: true,
				spaceBetween: 30,
				effect: 'fade',
				fadeEffect: { crossFade: true },
				slidesPerView: 1,
				autoHeight: true,
				/*pagination: {
					el: '.swiper-container__one--with-pagination .swiper-pagination',
					type: 'bullets',
					clickable: true
				},*/
				/*navigation: {
					nextEl: '.swiper-container__one--with-pagination .swiper-button-next',
					prevEl: '.swiper-container__one--with-pagination .swiper-button-prev',
				}*/
				/*controller: {
					control: this.mySwiperOne,
				},*/

			}),
    		this.mySwiperOne.controller.control = this.mySwiperTwo,
			this.mySwiperTwo.controller.control = this.mySwiperOne;

		},
		methods: {
			selectedFilter(event) {
				
				if (!event.target.classList.contains("filters-menu__link--active") ) {
					event.preventDefault();
					this.isLoading = true;
					this.activeFilter = event.target.attributes["data-category"].value;
				
					// this.mySwiperOne.slideTo(0,400,false);
					this.$data.selected = this.activeFilter;
					// simulate AJAX
					setTimeout(() => {
						this.isLoading = false;
					}, 500);

					let sliderObject = this.mySwiperOne;
					// console.log(sliderObject, "Swiper");

					setTimeout(() => {
						sliderObject.slideTo(0, 600);
					}, 0);

				}

			}
		},
		computed: {
			enquiryUrl() {
				return this.endpoint + '?&Room=';
			},
			...mapState({
				msg: state => state.msg,
			})
		}

};
</script>
<style>

</style>